import EmptyState from '@components/EmptyState'
import { ProgramStudentInfo } from '@interfaces/Student'
import React from 'react'

const ProgramIncorrectlySetup: React.FC<ProgramStudentInfo> = ({ ProgramId }) => (
  <EmptyState
    heading="Your program is setup incorrectly."
    bodyTxt="Please contact support to raise a case."
    img="/images/bug.svg"
    linkUrl={`/support/contact-us/?id=technical-support&cat=System%20access&pid=${ProgramId}`}
    btnTxt="View case"
    top="md"
  />
)

export default ProgramIncorrectlySetup
